import React from "react";
import EnsaConstant from "./EnsaConstant";

const ChartSLBGEkonomi = ({ dataLiterasi }) => {
	require("./Ensa.css");
	return (
		// <div className="container">
		//     {dataLiterasi.map((item) =>
		//         <div className="child" style={{
		//             height: "100%",
		//             backgroundColor: item.nama == 'Iklim Keamanan Sekolah' ? '#FEBC04'
		//                 : item.nama == 'Kualitas Pembelajaran' ? '#FF3838' : '#03C46B'
		//         }}>
		//             <div className="chart-label" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>{item.nama}</div>
		//             <div className="container2">
		//                 {item.listData.map((itemKat) =>
		//                     <div className="child2 label-gender" style={{ width: itemKat.skor + 'px', height: '100%', marginBottom: '10px' }}>{itemKat.kategori}</div>
		//                 )}
		//             </div>

		//         </div>
		//     )}
		// </div>

        <div className="container">
            {dataLiterasi.map((item) =>
                <div className="child" style={{
                    backgroundColor: item.nama == 'Iklim Keamanan Sekolah' ? '#FEBC04'
                        : item.nama == 'Kualitas Pembelajaran' ? '#FF3838' : '#03C46B'
                }}>
                    <div className="chart-label" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>{item.nama}</div>
                    <div style={{
                        display: 'flex',
                        flexWrap: 'nowrap', 
                        justifyContent: 'space-evenly', 
                        gap: "10px",
                        flexDirection: item.nama !== 'Iklim Keamanan Sekolah' ? 'column' : 'row',
                    }}>
                        {item.listData.map((itemKat) =>
                            item.nama === 'Iklim Keamanan Sekolah' ? (
                                <div className="label-gender" style={{width: itemKat.skor + '%',}}>{itemKat.kategori}</div>
                            ) : (
                                <div className="label-gender" style={{height: itemKat.skor + '%',}}>{itemKat.kategori}</div>
                            )
                        )}
                    </div>
                </div>
            )}
        </div>
	);
};

export default ChartSLBGEkonomi;
